import { ArrowDownOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useInfoUser } from "../../../store/UserStore";
import { useChatContext } from "../../../context/ChatContext";

export const NewMessage = ({
  handleClickButtonIsNewMessage,
  scrollToBottom,
}) => {
  const { languageMap } = useInfoUser();
  const { isNewMessage, isScrollToLastMessage } = useChatContext();
  return (
    <>
      {isNewMessage ? (
        <div className="bottom-scroll-shortcut">
          <Button
            className="text-[#005ae0] flex items-center shake-animation"
            onClick={handleClickButtonIsNewMessage}
          >
            <ArrowDownOutlined />
            {languageMap?.["message.scroll.newMessage"] ?? "New message"}
          </Button>
        </div>
      ) : (
        <div
          className={`${isScrollToLastMessage ? "bottom-scroll-shortcut" : "hidden"}`}
        >
          <Button
            className="bg-[#7f91b8] text-[white] scroll-button"
            icon={<ArrowDownOutlined />}
            onClick={() => {
              scrollToBottom();
            }}
          />
        </div>
      )}
    </>
  );
};
